import { QuestionnaireType } from 'src/API';
import { isUnitedKingdom } from 'src/app/shared/location-select/location.model';

export const QuestionnaireRequestUtils = {
  getQuestionnaireType(value: QuestionnaireType): string {
    if (value === QuestionnaireType.OSDIAndSPEED) {
      return 'OSDI and SPEED Combined';
    } else if (value === QuestionnaireType.DEQ) {
      return 'DEQ-5';
    } else {
      return QuestionnaireType[value];
    }
  }
};

export const getQuestionnaireKeys = () =>
  Object.values(QuestionnaireType)
    .filter(item => item !== QuestionnaireType.OSDIAndSPEED)
    .map(item => item.toLowerCase()) as string[];

export const MULTI_QUESTIONNAIRE_TYPES_IN_DISPLAY_ORDER: string[] = [
  'SPEEDII',
  'SPEED',
  'OSDI',
  'OSDI6',
  'DEQ',
  'DEWSIII_Q',
  'MEDICATION',
  'FITZPATRICK'
];

export const canSendAsMultiQuestionnaire = (type: string): boolean =>
  MULTI_QUESTIONNAIRE_TYPES_IN_DISPLAY_ORDER.indexOf(type) !== -1;

interface OrderableQuestionnaireRequest {
  id?: string;
  type?: string;
  createdAt?: string;
}

const displayOrderRank = (type: string): number => {
  const index = MULTI_QUESTIONNAIRE_TYPES_IN_DISPLAY_ORDER.indexOf(type);
  return index === -1 ? MULTI_QUESTIONNAIRE_TYPES_IN_DISPLAY_ORDER.length : index;
};

const compareStrings = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0);

export const compareQuestionnaireRequestsByDisplayOrder = (
  a: OrderableQuestionnaireRequest,
  b: OrderableQuestionnaireRequest
): number => {
  const rankDifference = displayOrderRank(a && a.type) - displayOrderRank(b && b.type);
  if (rankDifference !== 0) {
    return rankDifference;
  }

  const createdAtDifference = compareStrings((a && a.createdAt) || '', (b && b.createdAt) || '');
  if (createdAtDifference !== 0) {
    return createdAtDifference;
  }

  return compareStrings((a && a.id) || '', (b && b.id) || '');
};

export const submitStepLabelKeyForCountry = (country: string): string =>
  isUnitedKingdom(country) ? 'submitQuestionnaire' : 'sendToDoctor';

export const submitButtonLabelKeyForCountry = (
  country: string,
  defaultKey = 'Send to your doctor'
): string => (isUnitedKingdom(country) ? 'submitQuestionnaire' : defaultKey);
